import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AdminDashboard from './pages/admin-dashboard';
import ProductManagement from './pages/product-management';
import UserProfileSettings from './pages/user-profile-settings';
import EmployeeManagement from './pages/employee-management';
import WhatsAppAuthentication from './pages/whats-app-authentication';
import VendorDashboard from './pages/vendor-dashboard';
import ProductedRoute from "components/ProductedRoute";
import Expense from "pages/Expenses-sale/Expense";
import CustomerPage from "pages/customer-management/customer-management";
import SubscriptionPage from "pages/Subscription/SubscriptionPage";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<ProductedRoute><AdminDashboard /></ProductedRoute>} />
        <Route path="/admin-dashboard" element={<ProductedRoute><AdminDashboard /> </ProductedRoute>} />
        <Route path="/product-management" element={<ProductedRoute><ProductManagement /></ProductedRoute>} />
        <Route path="/user-profile-settings" element={<ProductedRoute><UserProfileSettings /></ProductedRoute>} />
        <Route path="/employee-management" element={<ProductedRoute><EmployeeManagement /></ProductedRoute>} />
        <Route path="/whats-app-authentication" element={<WhatsAppAuthentication />} />
        <Route path="/vendor-dashboard" element={<ProductedRoute><VendorDashboard /> </ProductedRoute>} />
        <Route path="/expenses" element={<ProductedRoute><Expense /> </ProductedRoute>} />
        <Route path="/customers" element={<ProductedRoute><CustomerPage /> </ProductedRoute>} />
        <Route path="/subscription" element={<SubscriptionPage /> } />
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
